import { useIntl } from "react-intl";

import { useMutation } from "@tanstack/react-query";

import { Prices } from "../../../api/prices";
import { MutationKey } from "../../../consts/mutation-keys";
import { useApiSuccess } from "../../../hooks/useApiSuccess";
import { useFetchError } from "../../../hooks/useFetchError";
import { FileResponse } from "../../../http-client";
import { ApiError } from "../../../types/api-error";
import { saveFile } from "../../../utils/save-file";

type ExportPricesParams = {
  regionId: number;
  datasetId: number;
};

export const useExportPrices = () => {
  const { formatMessage } = useIntl();

  const { handleSuccess } = useApiSuccess({
    snackbarText: formatMessage({
      id: "ACTION.PRICES_EXPORT_SUCCESS",
      defaultMessage: "Prices exported successfully.",
      description: "Prices export success message",
    }),
  });

  const {
    mutate: exportPrices,
    isPending,
    error,
  } = useMutation<FileResponse | null, ApiError, ExportPricesParams>({
    mutationKey: [MutationKey.ExportPrices],
    mutationFn: ({ regionId, datasetId }) =>
      Prices.exportByDataset({ path: { regionId, datasetId } }),
    onSuccess: response => {
      handleSuccess();
      if (response) {
        saveFile(response);
      }
    },
  });

  useFetchError(error);

  return { exportPrices, isPending };
};
